export const TRANSLATION_KEYS = {
  FIELDS: {
    NAME: 'pages.studies.fields.name',
    CONTACT_NAME: 'pages.studies.fields.contactName',
    CATEGORY: 'pages.studies.fields.category',
    STATUS: 'pages.studies.fields.status',
    START_DATE: 'pages.studies.fields.startDate',
    END_DATE: 'pages.studies.fields.endDate',
    ALLOW_PARTICIPANTS_TO_VIEW_PREVIOUS_RESPONSES:
      'pages.studies.fields.allowParticipantsToViewPreviousResponses.label',
  },
  STATUS: {
    PREFIX: 'pages.studies.status.', // e.g., pages.studies.status.draft
    DRAFT: 'pages.studies.status.draft',
    PUBLISHED: 'pages.studies.status.published',
    FINISHED: 'pages.studies.status.finished',
  },
  SEARCH: {
    CLEAR_BUTTON: 'pages.studies.search.clearButton',
    NO_RESULTS: 'pages.studies.search.noResults',
    ALL_STATUSES: 'pages.studies.search.allStatuses',
    ALL_CATEGORIES: 'pages.studies.search.allCategories',
  },
  ACTIONS: {
    UNPUBLISH: 'pages.studies.actions.unpublish',
  },
  UNPUBLISH: {
    MODAL: {
      TITLE: 'pages.studies.unpublish.modal.title',
      MESSAGE: 'pages.studies.unpublish.modal.message',
      CANCEL: 'pages.studies.unpublish.modal.cancel',
      CONFIRM: 'pages.studies.unpublish.modal.confirm',
    },
    SUCCESS: 'pages.studies.unpublish.success',
    ERROR: 'pages.studies.unpublish.error',
  },
  TABLE: {
    ACTIONS: 'table.actions',
  },
  DATA_GRID: {
    // Re-use generic datagrid keys if possible, or define specific ones
    PAGINATION: {
      DISPLAY_ROWS: 'dataGrid.pagination.displayRows',
      ROWS_PER_PAGE: 'dataGrid.pagination.rowsPerPage',
      FIRST_PAGE: 'dataGrid.pagination.firstPage',
      LAST_PAGE: 'dataGrid.pagination.lastPage',
      NEXT_PAGE: 'dataGrid.pagination.nextPage',
      PREVIOUS_PAGE: 'dataGrid.pagination.previousPage',
    },
  },
} as const;
